import tw, { css } from 'twin.macro'

export const FooterLinksStyle = css`
  ${tw`text-black`}
`

export const baseStyle = css`
  ${tw`min-h-220 lg:min-h-111 xl:min-h-125 relative lg:grid lg:grid-cols-2 text-black bg-primary-1 w-full px-6`}
`
